import { userInfoSync } from 'hub-http/userInfo';
import { AI_SUPPORTED_ASSET_TYPES, ASSET_TYPES, SUPPORTED_ASSET_TYPES } from 'personalization-lib/constants/assetTypes';
import { GATES, READ_SCOPES, WRITE_SCOPES } from 'personalization-lib/constants/auth';
const safeGetUserInfo = () => {
  try {
    return userInfoSync();
  } catch (error) {
    return undefined;
  }
};
const getUserLimits = () => {
  var _safeGetUserInfo;
  return (_safeGetUserInfo = safeGetUserInfo()) === null || _safeGetUserInfo === void 0 || (_safeGetUserInfo = _safeGetUserInfo.portal) === null || _safeGetUserInfo === void 0 ? void 0 : _safeGetUserInfo.limits;
};
export const getVariantsLimit = () => {
  var _getUserLimits;
  return ((_getUserLimits = getUserLimits()) === null || _getUserLimits === void 0 ? void 0 : _getUserLimits['variants-per-personalization-strategy']) || 0;
};
export const getStrategiesLimit = () => {
  var _getUserLimits2;
  return ((_getUserLimits2 = getUserLimits()) === null || _getUserLimits2 === void 0 ? void 0 : _getUserLimits2['personalization-max-strategies']) || 0;
};
const getUserGates = () => {
  var _safeGetUserInfo2;
  return (_safeGetUserInfo2 = safeGetUserInfo()) === null || _safeGetUserInfo2 === void 0 ? void 0 : _safeGetUserInfo2.gates;
};
export const hasGate = _gate => {
  var _getUserGates$include, _getUserGates;
  return (_getUserGates$include = (_getUserGates = getUserGates()) === null || _getUserGates === void 0 ? void 0 : _getUserGates.includes(_gate)) !== null && _getUserGates$include !== void 0 ? _getUserGates$include : false;
};
const getUserScopes = () => {
  var _safeGetUserInfo3;
  return (_safeGetUserInfo3 = safeGetUserInfo()) === null || _safeGetUserInfo3 === void 0 || (_safeGetUserInfo3 = _safeGetUserInfo3.user) === null || _safeGetUserInfo3 === void 0 ? void 0 : _safeGetUserInfo3.scopes;
};
export const hasScope = scope => {
  var _getUserScopes$includ, _getUserScopes;
  return (_getUserScopes$includ = (_getUserScopes = getUserScopes()) === null || _getUserScopes === void 0 ? void 0 : _getUserScopes.includes(scope)) !== null && _getUserScopes$includ !== void 0 ? _getUserScopes$includ : false;
};
export const hasScopes = scopes => scopes.every(scope => hasScope(scope));
export const getCanViewPersonalization = () => hasScope('personalize-view');
export const getCanCreateVariants = () => hasScope('personalize-edit');

/**
 * Returns true if the user has write access to the asset type.
 *
 * @param assetType - The asset type to check.
 * @returns Returns true/false if the user has write access to the asset type.
 */
export const canEditAssetType = assetType => Boolean(WRITE_SCOPES[assetType] && hasScopes(WRITE_SCOPES[assetType]));

/**
 * Returns true if the user has read access to the asset type.
 *
 * @param assetType - The asset type to check.
 * @returns Returns true/false if the user has read access to the asset type.
 */
export const canReadAssetType = assetType => {
  const hasRequiredScope = Boolean(READ_SCOPES[assetType] && hasScope(READ_SCOPES[assetType]));
  if (assetType === ASSET_TYPES.WEBSITE_PAGE) {
    return hasRequiredScope && hasGate(GATES.WEBSITE_PAGES);
  }
  return hasRequiredScope;
};

/**
 * Returns the asset types that the user has write access to.
 *
 * @param assetTypes - The asset types to filter. Defaults to all supported asset types.
 * @returns The asset types that the user has write access to.
 */
export const getWritableAssetTypes = (assetTypes = [...SUPPORTED_ASSET_TYPES]) => assetTypes.filter(canEditAssetType);

/**
 * Returns the asset types that the user has read access to.
 *
 * @param assetTypes - The asset types to filter. Defaults to all supported asset types.
 * @returns The asset types that the user has read access to.
 */
export const getReadableAssetTypes = (assetTypes = [...SUPPORTED_ASSET_TYPES]) => assetTypes.filter(canReadAssetType);

/**
 * Returns true if AI variant creation is supported for the asset type.
 *
 * @param assetType - The asset type to check. If undefined, returns true.
 * @returns Returns true if AI is supported for the asset type or if no asset type is provided.
 */
export const canCreateAiVariantForAssetType = assetType => !assetType || AI_SUPPORTED_ASSET_TYPES.includes(assetType);